import styled from 'styled-components';
import bgTile from '@/styles/img/bg_tile.png';
import bgTileDark from '@/styles/img/bg_tile_dark.png';

export const ServiceBackground = styled.div`
  background-image: url(${bgTile});
  background-repeat: tile;
  min-height: calc(100vh - 50px);

  [data-theme='dark'] & {
    background-image: url(${bgTileDark});
    background-color: var(--color-background-light);
  }
`;
